<template>
    <div id="CreateUser" class="starter-template">
        <b-container>
            <br>
            <h3 class="text-center">{{$t('REG')}}</h3>
            <b-form @submit.stop.prevent="onSubmit">
            <b-form-row>
                <b-col cols="5">
                    <br><br>
                    <h4>Email<span class="redC">*</span></h4>
                    <b-form-group>
                        <b-form-input
                                v-model.trim="$v.form.email.$model"
                                :state="validateState('email')"
                                aria-described-by="i-email"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="i-email"
                        ><h5>{{$t('R_EMAIL')}}</h5>
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <h4>{{$t('LOGIN1')}}<span class="redC">*</span></h4>
                    <b-form-group>
                        <b-form-input
                                v-model.trim="$v.form.userName.$model"
                                :state="validateState('userName')"
                                aria-described-by="input-1"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-1"
                        ><h5>{{$t('R_NAME')}}</h5>
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <h4>{{$t('PWD')}}<span class="redC">*</span></h4>
                    <b-form-group>
                        <b-form-input
                            type="password"
                            v-model.trim="$v.form.pwd.$model"
                            :state="validateState('pwd')"
                            aria-described-by="input-2"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            id="input-2"
                        ><h5>{{$t('R_PWD')}}<span class="redC">*</span></h5>
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <h4>{{$t('PWD2')}}</h4>
                    <b-form-group>
                        <b-form-input
                                type="password"
                                v-model.trim="$v.form.pwd2.$model"
                                :state="validateState('pwd2')"
                                aria-described-by="input-3"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-3"
                        ><h5>{{$t('R_PWD2')}}</h5>
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                    <b-col cols="2"></b-col>
                <b-col cols="5">
                    <br><br>
                    <h4>{{$t('FST_NAME')}}<span class="redC">*</span></h4>
                    <b-form-group>
                        <b-form-input
                                v-model.trim="$v.form.userFirstName.$model"
                                :state="validateState('userFirstName')"
                                aria-described-by="input-4"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-4"
                        ><h5>{{$t('R_NAME')}}</h5>
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <h4>{{$t('LST_NAME')}}<span class="redC">*</span></h4>
                    <b-form-group>
                        <b-form-input
                                v-model.trim="$v.form.userLastName.$model"
                                :state="validateState('userLastName')"
                                aria-described-by="input-5"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-5"
                        ><h5>{{$t('R_NAME')}}</h5>
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <br>

            <b-row align-v="center">
                <b-col cols="1">
                    <b-form-group>
                    <b-form-checkbox
                            size="lg"
                            v-model="$v.form.status.$model"
                            required
                            name="input-6"
                            value="accepted"
                            unchecked-value="not_accepted"
                        >
                    </b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col cols="10">
                    <b-button variant="link" @click="showTerms()"><h4>{{$t('TMS_ACC')}}<span class="redC">*</span></h4></b-button>
                </b-col>
            </b-row>

                </b-col>
                </b-form-row>

                <center>
                    <h4>{{$t('I_AM')}}:</h4>

                    <b-form-radio-group id="radio-group" v-model="form.userType" name="radio-sub-component">
                        <b-form-radio value="t"><h4>{{$t('TOURIST')}}</h4></b-form-radio>
                        <b-form-radio value="g"><h4>{{$t('GUIDE')}}</h4></b-form-radio>
                        <b-form-radio value="c"><h4>{{$t('TRAVEL_CR')}}</h4></b-form-radio>
                    </b-form-radio-group>
                    <br>

                    <b-row v-if="form.userType === 'g' || form.userType === 'c'">
                        <b-col cols="5" v-if="form.userType === 'c'">
                            <h4>{{$t('COM_NAME')}}<span class="redC">*</span></h4>
                            <b-form-group>
                                <b-form-input
                                        v-model.trim="$v.form.companyName.$model"
                                        :state="validateState('companyName')"
                                        aria-described-by="input-1"
                                ></b-form-input>
                                <b-form-invalid-feedback
                                        id="i-company"
                                ><h5>{{$t('R_ITEM_NAME')}}</h5>
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col cols="2"></b-col>
                        <b-col cols="5">
                            <h4>{{$t('URL_HOME')}} ({{$t('OPTION')}})</h4>
                            <b-form-group>
                                <b-form-input
                                        v-model.trim="$v.form.homeUrl.$model"
                                        :state="validateState('homeUrl')"
                                        aria-described-by="i-url"
                                ></b-form-input>
                                <b-form-invalid-feedback
                                        id="i-email"
                                ><h5>{{$t('R_URL')}}</h5>
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>

                </center>


            </b-form>

            <center>
            <b-button @click="save()" class="text-center">
                {{$t('ENTER')}}
            </b-button>
            </center>


        </b-container>

        <b-modal id="modal-1" size="xl">
            <span v-html="terms"></span>
            <template v-slot:modal-footer>
                <b-button @click="accept()">
                    {{ $t("ACCEPT")}}
                </b-button>
                <b-button @click="close()">
                    {{$t("CLOSE")}}
                </b-button>
            </template>
        </b-modal>

        <b-container fluid class="footer text-center">
            <b-button class="m-1" @click="$showDoc('About')">{{$t('ABOUT')}}</b-button>
            <b-button class="m-1" @click="$showDoc('Terms')">{{$t('TERMS')}}</b-button>
            <b-button class="m-1" @click="$showDoc('Privacy')">{{$t('PRIVACY')}}</b-button>
            <b-button class="m-1" @click.stop.prevent="showHelp=true"><font-awesome-icon icon="question" size="lg" :style="{ color: 'white' }" /></b-button>
        </b-container>

        <CheckCode
            v-on:signIn="signIn"
            v-bind:userName="form.userName"
            v-if="askCode"
        />

        <Help
            v-on:closeHelp="showHelp=false"
            v-bind:helpName="helpName"
            v-if="showHelp"
        />

    </div>
</template>

<script>
import { BContainer, BRow, BCol, BForm, BFormRow, BFormGroup, BFormRadio, BFormRadioGroup, BFormInput, BFormCheckbox, BModal, BButton, BFormInvalidFeedback } from 'bootstrap-vue';
import CheckCode from "./CheckCode.vue";
import { validationMixin } from "vuelidate";
import { helpers, required, requiredIf, minLength, maxLength, minValue, sameAs, email, url } from 'vuelidate/lib/validators';
import Help from "./Help.vue";
import {Cnst} from '@/plugins/Cnst.js';

const userNameR = helpers.regex('userNameR',/^(?!.*?[-\s]{2})[a-zA-Z.\-а-яА-ЯёЁ\s]+$/);
const itemNameR = helpers.regex('itemNameR',/^(?!\.)(?!.*?[-\s]{2})(?!.*?[']{3})[a-zA-Z0-9.,()\-'а-яА-ЯёЁ\s]+$/);

export default {
  name: 'CreateUser',
  components: {
      CheckCode, Help,
      BContainer, BRow, BCol, BForm, BFormRow, BFormGroup, BFormRadio, BFormRadioGroup, BFormInput, BFormCheckbox, BModal, BButton, BFormInvalidFeedback
  },
  mixins: [validationMixin],
  data: function() {
    return {
      form: {
        userName: '',
        userFirstName: '',
        userLastName: '',
        email: '',
        pwd: '',
        pwd2: '',
        status,
        userType: 't',
        companyName: '',
        homeUrl: ''
      },
      mess: '',
      terms: '',
      askCode: false,
      helpName: 'HelpCreateUser',
      showHelp: false,
      intLoc: this.$i18n.locale,
      url: ''
    }
  },
  mounted() {
    this.form.status = this.$store.state.accept;
    this.getTerms();
  },
  methods: {
    validateState(name) {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
    },
    async getTerms() {
        try {
            const response = await this.$http.get('/getDoc', {
                params: {
                    title: 'Terms',
                    locale: this.intLoc
                }
            });
            this.terms = response.data;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    showTerms() {
        this.$bvModal.show('modal-1');
    },
    async save() {
        this.$v.form.$touch();
        if(this.$v.form.$anyError) return;
        try {
            await this.$http.post('createUser', {
                userName: this.form.userName,
                userEmail: this.form.email,
                userFirstName: this.form.userFirstName,
                userLastName: this.form.userLastName,
                userPwd: this.form.pwd,
                userType: this.form.userType,
                companyName: this.form.companyName,
                homeUrl: this.form.homeUrl
            });
            let body = 'username='+this.form.userName+'&password='+this.form.pwd;
            const response = await this.$http.post('/callback?client_name=FormClient', body);
            let result = await response.data;
            this.userName = result.userName;
            this.$store.commit('setCurUserName', '');
            if(result.confirmed != 'true') this.askCode = true;
            else {
                this.signIn(true);
            }
         } catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('CreateUser: onSubmit() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    },
    async signIn(checked) {
        this.askCode = false;
        if(!checked) {
            this.$store.commit('setCurUserName', '');
            return;
        }
        //this.$store.commit('setCurUserName', this.userName);
        let body = 'username='+this.form.userName+'&password='+this.form.pwd;
        try {
            const response = await this.$http.post('/callback?client_name=FormClient', body);
            let result = await response.data;
            this.$store.commit('setCurUserName', result.userName);
            this.$router.push({
                path: 'Map/UserMap/_/'+this.$addEncHyp(result.userName),
                query: {
                    published: true,
                    blocked: false,
                    all: false
                }
            });
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    accept() {
        this.form.status='accepted';
        this.$store.commit('setAccept', 'accepted');
        this.$bvModal.hide('modal-1');
    },
    close() {
        this.$bvModal.hide('modal-1');
    },
    setCompany() {
        //alert('About');
    }
  },
  validations: {
    form: {
        userName: {
            required,
            userNameR,
            minLength: minLength(1),
            maxLength: maxLength(Cnst.MAX_NAME_SIZE)
        },
        userFirstName: {
            required,
            userNameR,
            minLength: minLength(1),
            maxLength: maxLength(Cnst.MAX_NAME_SIZE)
        },
        userLastName: {
            required,
            userNameR,
            minLength: minLength(1),
            maxLength: maxLength(Cnst.MAX_NAME_SIZE)
        },
        email: {
            required,
            email,
            maxLength: maxLength(Cnst.MAX_NAME_SIZE)
        },
        pwd: {
            required,
            minLength: minLength(6),
            maxLength: maxLength(Cnst.MAX_NAME_SIZE)
        },
        pwd2: {
            required,
            sameAs: sameAs(function () { return this.form.pwd })
        },
        status: {
            required
        },
        companyName: {
          required: requiredIf(function () { return this.form.userType == 'c' } ),
          itemNameR,
          minLength: minLength(2),
          maxLength: maxLength(Cnst.MAX_ITEM_NAME_SIZE)
        },
        homeUrl: {
          url,
          minLength: minLength(4),
          maxLength: maxLength(Cnst.MAX_ITEM_NAME_SIZE)
        },
        maxSize: {
          minValue: minValue(0)
        },
    },
  },
    watch: {
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        this.getTerms();
    }
  }
}

</script>

<style scoped>
>>> h5{
    color: red;
    font-size: 1.2em;
}
.redC{
    color: red;
}
.pl2em{
    padding-left: 2em;
}

</style>

